import React from "react";

import TableRowContainer from "../Components/TableRowContainer";
import { formatTimeFromUtc } from "../../../utils/formatters";
import { icons } from "../../../constants/icons";
import { StatusENUM } from "../../../types/common";

type Props = {
  coachId: string;
  name?: string;
  activationStatus: string;
  authStatus?: string;
  inviteDates: string[];
  status: StatusENUM;
  onDisableUser?: (userId: string, status: StatusENUM) => void;
  resendInvitation: () => void;
};

const getStatusIcon = (status: string) => {
  if (status === StatusENUM.invited) {
    return icons.coachInvitedStatus;
  } else if (status === StatusENUM.registered) {
    return icons.coachRegisteredStatus;
  }
};

const TableRow = React.memo(
  ({
    coachId,
    name,
    inviteDates,
    status,
    onDisableUser,
    activationStatus,
    authStatus,
    resendInvitation,
  }: Props) => {
    return (
      <TableRowContainer
        id={coachId}
        authStatus={authStatus}
        status={status}
        onDisableUser={onDisableUser}
        activationStatus={activationStatus}
        resendInvitation={resendInvitation}
      >
        <div className="w-[400px]">
          <p>{name}</p>
        </div>
        <div className="w-[300px]">
          <p>-</p>
        </div>
        <div className="w-[200px]">
          <p>{formatTimeFromUtc(inviteDates[0])}</p>
        </div>
        <div className="w-[150px] capitalize flex">
          {status && (
            <img
              className="mr-1.5"
              alt={"status"}
              src={getStatusIcon(status)}
            />
          )}
          <p>{status || ""}</p>
        </div>
        <div className="w-[100px] ">
          <img
            alt="status"
            src={
              activationStatus !== StatusENUM.disabled
                ? icons.clinicActiveStatus
                : icons.clinicDisabledStatus
            }
          />
        </div>
      </TableRowContainer>
    );
  }
);

export default TableRow;
